module.exports = __webpack_public_path__ + "media/images/proof_links/tumblr-d0e8574cd649054fc266a52cfbdaaee3.svg";